module.exports = __webpack_public_path__ + "static/img/05.4c890d55.png";